import { Component, OnInit } from '@angular/core';
import { SettingsService } from './../settings.service';
import { ActivatedRoute,Router } from '@angular/router';
import { PatientsService } from '../patients.service';
import { AppointmentsService } from "./../appointments.service";

@Component({
    selector: 'app-booking-nav',
    templateUrl: './booking-nav.component.html',
    styleUrls: ['./booking-nav.component.scss'],
    standalone: false
})
  export class BookingNavComponent implements OnInit {
    param
    ApptsByRoom
    queryParams
      constructor(private route: ActivatedRoute,private router: Router,private PatientsService:PatientsService,public SettingsService:SettingsService,public appointmentService: AppointmentsService) { }
    
      ngOnInit(): void {
        this.queryParams = this.route.snapshot.queryParams;
          this.SettingsService.getClinic(this.queryParams.g).subscribe(async(data:any)=>{
           if(data.error){
            return 
           }
           if(data.ApptsByRoom){
             this.ApptsByRoom='true'
           }
           else{
            this.ApptsByRoom='false'
           }
          }) 
    
        ;
      }
    
    }
    

